<template>
    <v-container fluid class="mx-0 px-0 py-0 my-0">
        <v-row class="mx-0 my-0 page-gutter">
          <v-col cols="12" class="text-center">
            <h2 class="title">
              {{promo.title}}
            </h2>
          </v-col>
        </v-row>
        <v-row class="text pt-5 mx-0 my-0 page-gutter">
            <span v-html="promo.content"></span>
        </v-row>
    </v-container>
  </template>
  
  
  <script>
   import restApi from "@/rest-api";
  
    export default {
      data() {
          return {
              promo:{},
              id: 0
          }
      },
      created() {
        this.fetchPromo(this.$route.params.promoId)
      },
      methods: {
        fetchPromo(id) {
          var search = `/promo/${id}`;
          restApi
          .get(search)
          .then(response => {
                this.promo = response.data.promo[0]
          })
          .catch((error) => {
              console.log(error);
          });
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
      @media only screen and (min-width: 600px){
          .promo{
              padding-top: 7%;
              width: 70%;
              height: auto;
              padding-bottom: 7%;
          }
      }
  
      @media only screen and (max-width: 600px){
          .promo{
              padding-top: 20%;
              width: 90%;
              height: auto;
              padding-bottom: 20%;
          }
      }
  
      .title{
          text-align:center;
          font-weight:normal;
          padding-top: 3%;
          padding-bottom: 2%;
          font-size: 3vh!important;
      }
      .text{
          font-size: 2vh!important;
          padding:0% 10% 0% 10%; 
      }
  
  </style>